export default "__VITE_ASSET__75623029__"